import { useTranslation } from 'next-i18next';
import { ChevronRightIcon } from '@zep/icons';
export function CustomContactLink() {
  const {
    t
  } = useTranslation(['subscription']);
  return <a href={t('subscription:subscription.salesmap.link')} target="_blank" className="flex cursor-pointer items-center justify-end" data-sentry-component="CustomContactLink" data-sentry-source-file="CustomContactLink.tsx">
      <span className="cursor-pointer text-[15px] font-[700] text-[#27262ECC]">
        {t('subscription:payment.duration.contact', '도입 문의하기')}
      </span>
      <ChevronRightIcon width={20} height={20} data-sentry-element="ChevronRightIcon" data-sentry-source-file="CustomContactLink.tsx" />
    </a>;
}